import React from "react";
import { CloseIcon } from "../../../../../../components/icons";
import { IoCheckmark } from "react-icons/io5";
import { useBookingEditText } from "../../../text";
import { cn } from "../../../../../../utils/classnames";

const ChargeSuccessModal = ({
  show,
  onClose,
  amountNumberText,
  oldBooking,
  chargeAmountNumber
}) => {
  const { t } = useBookingEditText();

  const getTitle = () => {
    if (chargeAmountNumber > 0) {
      return {
        title: `The amount of ${amountNumberText} JPY has been charged successfully`,
        subtitle: "Please make sure to review all modifications thoroughly, as changes are irreversible"
      }
    }
    return {
      title: "Booking details updated",
    }
  };

  const getTitleStyle = () => {
    if (chargeAmountNumber > 0) {
      return "#282828";
    }
    return "#3CAEA3";

  };

  return (
    <div
      className={cn(
        "tw:fixed tw:inset-0 tw:z-[9999] tw:flex tw:items-center tw:justify-center",
        show ? "tw:block" : "tw:hidden"
      )}
    >
      <div
        aria-label="Close modal backdrop"
        className="tw:absolute tw:inset-0 tw:bg-[#00000099]"
        onClick={onClose}
      />
      <div className="tw:relative tw:z-[10000] tw:w-[calc(100%-24px)] tw:lg:w-[660px] tw:rounded-[8px] tw:bg-white tw:px-4 tw:py-5 tw:md:px-10 tw:md:py-8 tw:shadow-lg">
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="tw:absolute tw:top-6 tw:right-6"
        >
          <CloseIcon color="#7c7b7b" size={16} />
        </button>

        <div className="tw:flex tw:flex-col tw:items-center tw:justify-center tw:gap-3 tw:my-6">
          <div className="tw:flex tw:h-[32px] tw:w-[32px] tw:items-center tw:justify-center tw:rounded-full tw:bg-[#3CAEA3]">
            <IoCheckmark className="tw:text-white tw:text-[22px]" />
          </div>
          <div className={`tw:text-center ${getTitleStyle} tw:text-[18px] tw:font-[600] tw:leading-[27px] tw:font-hanken-grotesk`}>
            {getTitle().title}
          </div>
          {
            getTitle().subtitle && (
              <div className="tw:text-center tw:text-[#8D8D8D] tw:text-[15px] tw:font-[400] tw:leading-[22px] tw:font-hanken-grotesk">
                {getTitle().subtitle}
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default ChargeSuccessModal;
